export function initVideoPlayer() {
  const initVideoPlayers = () => {
    document.querySelectorAll( '.video-player' ).forEach( ( player ) => {
      const video  = player.querySelector( '.video-player__video' );
      const facade = player.querySelector( '.video-player__facade' );
      const btn    = player.querySelector( '.video-player__play' );
  
      if ( ! video || ! facade ) return;
  
      const activate = () => {
        player.dataset.state = 'playing';
        video.play();
      };
  
      btn?.addEventListener( 'click', activate );
  
      // Restore façade when video ends
      video.addEventListener( 'ended', () => {
        player.dataset.state = 'idle';
        video.load(); // reset to poster frame
      } );
  
      // Keep state in sync with native controls
      video.addEventListener( 'play', () => {
        player.dataset.state = 'playing';
      } );
  
      video.addEventListener( 'pause', () => {
        if ( ! video.ended ) {
          player.dataset.state = 'paused';
        }
      } );
    } );
  };
  
  document.addEventListener( 'DOMContentLoaded', initVideoPlayers );
}